<script>
import CustomGraph from './CustomGraph.vue'

export default {
  extends: CustomGraph
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/Widget.vue